import React, { useState } from "react";
import { Space, Button, Table, Modal, message } from "antd";
import { useNavigate } from "react-router-dom";
import commonUtility from "../../utility/Utils";
import { PRINT_BASE_URL, BASE_API_URL } from "../../utility/URL";
import axios from "axios";
import MemberService from "../../api/member.service";

const MembershipListView = ({ MembershipList, onRefresh }) => {
  const showTotal = (total, range) =>
    `${range[0]}-${range[1]} of ${total} items`;
  const [page, setPage] = useState(1);

  const handleContinue = (enrollment_id) => {
    Modal.confirm({
      title: "Are you sure you want to continue?",
      onOk: async () => {
        try {
          await MemberService.MemberContinue({
            formdata: { enrollment_id: enrollment_id },
          });
          message.success("Continued successfully!");
          if (onRefresh) onRefresh();
        } catch (error) {
          message.error("Failed to continue.");
        }
      },
    });
  };

  const tempcolumns = [
    {
      title: "#",
      dataIndex: "index",
      render: (text, record, index) => (page - 1) * 10 + ++index,
      width: "5%",
    },
    {
      title: "Name",
      dataIndex: "member_fname",
      key: "member_fname",
      sorter: (a, b) => {
        const nameA = `${a.member_fname} ${a.member_lname}`;
        const nameB = `${b.member_fname} ${b.member_lname}`;
        return nameA.localeCompare(nameB);
      },
      render: (selectedObj, record) => (
        <Space>
          <span>
            {record.member_fname} {record.member_lname}
          </span>
        </Space>
      ),
    },
    {
      title: "Programme",
      dataIndex: "programme",
      key: "programme",
    },
    {
      title: "Discontinue Date",
      dataIndex: "inactive_date",
      key: "inactive_date",
    },
    {
      title: "Discontinue Note",
      dataIndex: "discontinue_note",
      key: "discontinue_note",
    },
    {
      title: "Action",
      key: "action",
      width: 120,
      render: (record) => (
        <Button
          htmlType="button"
          type="primary"
          size="small"
          shape="round"
          onClick={() => handleContinue(record.enrollment_id)}
        >
          Continue
        </Button>
      ),
    },
  ];

  return (
    <Table
      rowKey="enrollment_id"
      columns={tempcolumns}
      className="nestedTable"
      dataSource={MembershipList}
      size="small"
      pagination={{
        showTotal,
        onChange(current) {
          setPage(current);
        },
      }}
    />
  );
};

export default MembershipListView;
